<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import { urlMethods } from "@/state/helpers";
import Swal from "sweetalert2";
export default {
  components: {},
  data: function() {
    return {
      voucherText: "",
      isLoading: false,
    };
  },
  computed: {
    currentUser: function() {
      return this.$store.getters["auth/currentUser"];
    },
    currentTab: function() {
      return this.$store.getters["sale/currentTab"];
    },
    voucher: function() {
      return this.$store.getters["sale/voucher"];
    },
  },
  methods: {
    ...urlMethods,
    searchVoucher: async function(e) {
      let that = this;
      e.preventDefault();
      this.isLoading = true;
      try {
        let res = await this.postUrl({
          url: "search-voucher",
          data: { code: this.voucherText },
        });
        if (
          typeof res == "undefined" ||
          typeof res.data == "undefined" ||
          typeof res.error == "undefined" ||
          typeof res.message == "undefined"
        ) {
          throw "Không thế kết nối server";
        }
        if (res.error) {
          throw res.message;
        }
        if (!res.data) {
          throw "Voucher không khả dụng";
        }
        let voucher = res.data;
        var total_amount = this.currentTab.info.totalAmount;
        if (total_amount < voucher.min_order) {
          throw "Voucher chỉ áp dụng cho đơn hàng có Tổng tiền hàng tối thiểu " +
            parseFloat(voucher.min_order).toLocaleString() +
            "đ";
        }
        this.$store.dispatch("sale/setVoucher", voucher);
        this.$bvModal.hide("modal-voucher");
        if (!(!voucher.with_vip && this.currentTab.info.customerDiscount > 0)) {
          this.$store.dispatch("sale/recalcData");
        }
      } catch (error) {
        console.log(error);
        let text = typeof error == "string" ? error : JSON.stringify(error);
        this.$store.dispatch("sale/setNoti", { text: text, type: "error" });
        this.isLoading = false;
      }
      return false;
    },
    removeDiscountVoucher() {
      this.$store.dispatch("sale/removeDiscountVoucher");
      this.voucherText = "";
      this.closePopup();
    },
    closePopup() {
      this.$bvModal.hide("modal-voucher");
    },
  },
  mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "modal-voucher") {
        setTimeout(() => {
          this.isLoading = false;
          if (typeof this.$refs.voucherText != "undefined")
            this.$refs.voucherText.focus();
          if (typeof this.voucher.name != "undefined")
            this.voucherText = this.voucher.name;
        }, 100);
      }
    });
  },
};
</script>

<template>
  <div>
    <b-modal
      id="modal-voucher"
      title="Giảm voucher"
      title-class="font-18"
      hide-footer
    >
      <form
        class="form-horizontal"
        @submit="searchVoucher"
        role="form"
        v-if="!(typeof voucher.id != 'undefined' && voucher.id > 100)"
      >
        <b-form-group
          class="mb-3"
          label-cols-lg="3"
          label="Nhập voucher"
          label-for="voucherText"
          ><b-form-input
            type="text"
            ref="voucherText"
            :disabled="isLoading"
            autocomplete="off"
            for="voucherText"
            v-model="voucherText"
          ></b-form-input
        ></b-form-group>
        <div class="text-right">
          <b-button type="submit" variant="primary" :disabled="isLoading"
            ><i class="bx bx-check"></i> Xác nhận</b-button
          >
        </div>
      </form>
      <div class="text-center" v-else>
        <p>Voucher đã được áp dụng: {{ voucherText }}</p>
        <b-button
          @click="removeDiscountVoucher"
          variant="danger"
          :disabled="isLoading"
          ><i class="bx bx-check"></i> Xoá voucher</b-button
        >
        <b-button @click="closePopup" variant="primary" :disabled="isLoading"
          ><i class="bx bx-check"></i> Xác nhận</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
